import { Outlet } from '@tanstack/react-router';

export function AppsContentLayout() {
  return <Outlet />;
}
